/**
 * Display version for the Angular app.
 *
 * Electron / fat-client packaging overwrites this file at build time from
 * electron_packaging/config/build.config.json ("version"), then restores it.
 * Do not treat the value below as the desktop release version — set that in
 * build.config.json (or pass --version to the packaging script).
 *
 * For standalone web builds (non-desktop), update this constant (or your CI)
 * as needed.
 */
export const APP_VERSION = '0.0.0-dev';
